import React from 'react';
import RecommendTagDetailNavbar from '../RecommendTagDetailNavbar';
import RecommendTagDetailInfo from '../RecommendTagDetailInfo';
import RecommendTagDetailItemList from '../RecommendTagDetailItemList';
import './RecommendTagDetailWrap.scss';

const RecommendTagDetailWrap = (props) => {
  const { recommendTagDetail } = props;
  const { recommendTagInfo, recommendTagItemList } = recommendTagDetail;

  return (
    <div className="recommend-tag-detail-wrap">
      {/* 하단 네브바 */}
      <RecommendTagDetailNavbar recommendTagId={recommendTagInfo.recommendTagId} />

      {/* 추천 상품 후기 정보 */}
      <RecommendTagDetailInfo recommendTagInfo={recommendTagInfo} />

      {/*/!* 추천 상품 후기 아이템 리스트*!/*/}
      <RecommendTagDetailItemList recommendTagItemList={recommendTagItemList} />
    </div>
  );
};

export default RecommendTagDetailWrap;
